import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const token = localStorage.getItem("dp_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("dp_token"))
      .finally(() => setLoading(false));
  }, []);

  const refreshUser = async () => {
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const login = async (email, password) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("dp_token", res.data.token);
      await refreshUser();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e, "Falha no login") };
    }
  };

  const register = async (payload) => {
    try {
      const res = await api.post("/auth/register", payload);
      localStorage.setItem("dp_token", res.data.token);
      await refreshUser();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e, "Falha no registro") };
    }
  };

  const loginWithGoogle = React.useCallback(async (sessionId, profession) => {
    try {
      const res = await api.post("/auth/google/session", { session_id: sessionId, profession: profession || null });
      localStorage.setItem("dp_token", res.data.token);
      await refreshUser();
      return { ok: true, isNew: res.data.is_new };
    } catch (e) {
      return { ok: false, error: formatApiError(e, "Falha no login com Google") };
    }
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("dp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithGoogle, logout, setUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
